<template>
  <div>
    <h2>Cancellation Policy</h2>
    <p>
      Your purchase of certain Services may require enrollment in a payment plan involving automatic renewal (a “Recurring Subscription”), and if you
      purchase such a Recurring Subscription, you authorize Cofocus to maintain your account information and charge that account automatically upon
      the renewal with no further action required by you. The length of your Recurring Subscription will be provided when you make your purchase.
    </p>
    <p>
      Your Recurring Subscription will automatically renew unless you cancel it. In the event that Cofocus is unable to charge your account as
      authorized by you when you enrolled in a Recurring Subscription, Cofocus, may, in its sole discretion: (i) bill you for your Services and
      suspend your access to the Services until payment is received, and/or (ii) seek to update your account information through third party sources
      (i.e., your bank or a payment processor) to continue charging your account as authorized by you. You may cancel your subscription through your
      account or by emailing us at support@cofocus.one.
    </p>
    <p>
      You may cancel a Recurring Subscription at any time, but if you cancel your Recurring Subscription before the end of the current subscription
      period, we will not refund any subscription fees already paid to us. Following any cancellation, however, you will continue to have access to
      the applicable Services through the end of your current subscription period. Cofocus may change the prices charged for Recurring Subscriptions
      at any time by posting updated pricing through the Services; provided, however, that the prices for your Recurring Subscription will remain in
      force for the duration of the subscription period for which you have paid. After that period ends, your use of the applicable Services will be
      charged at the then-current subscription price. If you do not agree to these price changes, you must cancel your Recurring Subscription at least
      ten days before the changes take effect.
    </p>
    <p>
      If you do not cancel, your Recurring Subscription will automatically renew at the then-current price at the time of renewal and for the same
      duration as the initial subscription term, and Cofocus will charge your on-file payment card or method on the first day of the renewal of the
      subscription term.
    </p>
  </div>
</template>

<script>
export default {
  name: "CancellationPolicy",
  mounted() {
    window.mixpanel.track("Visit Cancellation Policy");
  },
};
</script>
